(function () {
  if (window.__bystormInit) return;
  window.__bystormInit = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduceMotion) {
    document.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('will-reveal'));
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.01, rootMargin: '0px' });
    document.querySelectorAll('[data-reveal]').forEach(el => obs.observe(el));
  }

  const navToggles = document.querySelectorAll('[data-nav-toggle]');
  function closeAllDropdowns(except) {
    navToggles.forEach(t => {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      t.closest('.nav-item').classList.remove('open');
    });
  }
  navToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns(toggle);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      toggle.closest('.nav-item').classList.toggle('open', !isOpen);
    });
    toggle.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.closest('.nav-item').classList.remove('open');
        toggle.focus();
      }
    });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.nav-item')) closeAllDropdowns(null);
  });

  const hamburger = document.getElementById('hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const main = document.getElementById('main');
  let lastFocused = null;

  function getFocusable(container) {
    return container.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
  }
  function openMobileMenu() {
    lastFocused = document.activeElement;
    mobileMenu.classList.add('open');
    hamburger.classList.add('open');
    hamburger.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if ('inert' in HTMLElement.prototype) main.inert = true;
    const focusables = getFocusable(mobileMenu);
    if (focusables.length) focusables[0].focus();
  }
  function closeMobileMenu() {
    mobileMenu.classList.remove('open');
    hamburger.classList.remove('open');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if ('inert' in HTMLElement.prototype) main.inert = false;
    if (lastFocused) lastFocused.focus();
  }
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      if (mobileMenu.classList.contains('open')) closeMobileMenu(); else openMobileMenu();
    });
    mobileMenu.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const focusables = Array.from(getFocusable(mobileMenu));
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMobileMenu();
    });
  }

  const stickyCta = document.getElementById('sticky-cta');
  const hero = document.querySelector('.hero');
  if (stickyCta && hero && 'IntersectionObserver' in window) {
    const heroObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          stickyCta.classList.remove('visible');
          stickyCta.setAttribute('aria-hidden', 'true');
        } else {
          stickyCta.classList.add('visible');
          stickyCta.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });
    heroObs.observe(hero);
  }

  fetch('/cart.js').then(r => r.ok ? r.json() : null).then(data => {
    if (!data) return;
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = String(data.item_count || 0);
      const cartLink = el.closest('a');
      if (cartLink) cartLink.setAttribute('aria-label', `Cart, ${data.item_count} items`);
    });
  }).catch(() => {});

  // Carousel arrows — scroll the product track by one card
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-carousel-track]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.pcard');
      return card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
    }
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  // Shoppable UGC videos — lazy-load source, autoplay muted only in view, pause off-screen.
  // No autoplay under reduced-motion (poster + play button instead).
  var sugcReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sugcVideos = document.querySelectorAll('.sugc-media video');
  function sugcLoad(v) {
    if (v.dataset.loaded) return;
    var s = v.querySelector('source[data-src]');
    if (s) { s.src = s.getAttribute('data-src'); v.load(); }
    v.dataset.loaded = '1';
  }
  if (sugcVideos.length && 'IntersectionObserver' in window) {
    var sugcObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          sugcLoad(v);
          if (!sugcReduce) { v.play().then(function(){ v.closest('.sugc-media').classList.add('is-playing'); }).catch(function(){}); }
        } else { v.pause(); }
      });
    }, { threshold: 0.5 });
    sugcVideos.forEach(function (v) { sugcObs.observe(v); });
  }
  document.querySelectorAll('[data-sugc-mute]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.closest('.sugc-media').querySelector('video'); if (!v) return;
      v.muted = !v.muted;
      btn.classList.toggle('is-muted', v.muted);
      btn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
    });
  });
  document.querySelectorAll('[data-sugc-play]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var media = btn.closest('.sugc-media'); var v = media.querySelector('video'); if (!v) return;
      sugcLoad(v);
      if (v.paused) { v.play().then(function(){ media.classList.add('is-playing'); }).catch(function(){}); }
      else { v.pause(); media.classList.remove('is-playing'); }
    });
  });
})();